import { useMemo } from 'react';
import type { AuditTrailItem } from 'shared/components';
import { noValue } from 'shared/constants';
import { XeroCounterparty } from 'shared/data/webApp/v1';
import {
    ApiIntegrationsXeroPaymentDetailsEventType,
    GetXeroCounterpartyPaymentDetailsHistory,
} from 'shared/data/webApp/v2';

import { messages } from './InfoPanel.messages';

export const useFinancialDetailsData = (contact: XeroCounterparty | null): XeroCounterparty['financialDetails'] => {
    return {
        bankAccountName: contact?.financialDetails.bankAccountName ?? noValue,
        bankAccountNumber: contact?.financialDetails.bankAccountNumber ?? noValue,
        sortCode: contact?.financialDetails.sortCode ?? noValue,
        currency: contact?.financialDetails.currency ?? noValue,
        reference: contact?.financialDetails.reference ?? noValue,
    };
};

export const usePaymentDetailsHistoryAuditTrail = (
    historyData?: GetXeroCounterpartyPaymentDetailsHistory['response']
) => {
    return useMemo(() => {
        return (historyData?.items ?? []).reduce<AuditTrailItem[]>((acc, item) => {
            let message = '';

            switch (item.eventType) {
                case ApiIntegrationsXeroPaymentDetailsEventType.create:
                    message = messages.added({
                        bankAccountName: item.bankAccountName,
                    });

                    break;

                case ApiIntegrationsXeroPaymentDetailsEventType.update:
                    message = messages.edited({
                        bankAccountName: item.bankAccountName,
                    });

                    break;

                case ApiIntegrationsXeroPaymentDetailsEventType.delete:
                    message = messages.removed({
                        bankAccountName: item.bankAccountName,
                    });

                    break;

                default:
                    break;
            }

            if (item.eventType !== ApiIntegrationsXeroPaymentDetailsEventType.unspecified) {
                acc.push({
                    message,
                    date: item.createdDate,
                    id: `${item.paymentDetailsId}-${item.eventType}-${item.createdDate}`,
                    author: item.author,
                });
            }

            return acc;
        }, []);
    }, [historyData?.items]);
};
